import React from 'react'
import {useSolv} from "./components/SolvProvider";
import {useIntlEx} from "./components/IntlUtils.js"
import getLogger from "./components/Logging.js"
import './App.css'
import {AppLogo, useAlert} from "./components/FormComps";
import {ModalDialog} from "./components/DialogUtils";

// const APP_VER = process.env.REACT_APP_VERSION

const log = getLogger("AboutDialog")

export function AboutSolvDialog(props)  {

  const {env} = useSolv()
  const {intl} = useIntlEx()
  const {alert} = useAlert()

  function handleOpenDialog() {
  }

  function handleCloseDialog() {
  }

  return (

    <ModalDialog
      dialogId="dlg_about_solv"
      size="md" keyboard="true" backdrop="true"
      alert={alert}
      onOpen={handleOpenDialog}
      onClose={handleCloseDialog}>

      <ModalDialog.Header
        title={intl.msg("about_title", {appName: env.displayName})}
        alert={alert}
      />

      <ModalDialog.Body>

        <div className="d-flex gap-3">

          <div className="d-flex flex-column h-100 p-3" style={{width: "180px", backgroundColor: "color-mix(in srgb, var(--app-panel-color) 43%, transparent)", border: "1px solid var(--form-control-border-color)"}}>
            <div className="d-flex justify-content-center w-100 mb-auto">
              <AppLogo size="md" width="80"/>
            </div>
            <div className="mt-4">
              {
                env.slogan &&
                <div className="mb-2" style={{fontSize: "9pt", fontWeight: "700"}}>
                  {env.slogan}
                </div>
              }
              {
                env.descriptor &&
                <div style={{fontSize: "9pt", fontWeight: "400", color: "var(--color-muted)"}}>
                  {env.descriptor}
                </div>
              }
            </div>
          </div>

          <div>

            <div style={{fontSize: "12pt", fontWeight: "700"}}>
              {env.displayName}
            </div>

            <div style={{fontSize: "12pt", fontWeight: "700"}}>
              {intl.msg("app_version", {version: env.appVersion})}
            </div>

            <div className="mt-2" style={{fontSize: "12pt", fontWeight: "400"}}>
              {intl.msg("footer_copyright", {copyrightYear: new Date().getFullYear(), entityName: env.entityName, entityAddress: env.entityAddress})}
            </div>

          </div>

        </div>

      </ModalDialog.Body>

      {/*<ModalDialog.Footer>*/}
      {/*  <ModalDialog.Footer.Controls>*/}
      {/*    <button type="button" className="btn btn-secondary" data-dismiss="modal">*/}
      {/*      {intl.msg("cancel")}*/}
      {/*    </button>*/}
      {/*    {*/}
      {/*      !alert &&*/}
      {/*      <button type="button" className="btn btn-danger" onClick={handleDeleteClick}>*/}
      {/*        {intl.msg("delete")}*/}
      {/*      </button>*/}
      {/*    }*/}
      {/*  </ModalDialog.Footer.Controls>*/}
      {/*</ModalDialog.Footer>*/}

    </ModalDialog>
      //
      // <div className="modal fade" id="dlg_about_solv" tabIndex="-1" role="dialog" aria-labelledby="dlg_about_solv" aria-hidden="true">
      //   <div className="modal-dialog modal-md" role="document">
      //     <div className="modal-content">
      //       {/* <div className="modal-header">
      //         <h5 className="modal-title">{intl.fm("about_title")}</h5>
      //         <button type="button" className="close" data-dismiss="modal" aria-label="Close">
      //           <span aria-hidden="true">&times;</span>
      //         </button>
      //       </div> */}
      //       <div className="modal-body">
      //         <div className="row" style={{margin: "20px 0"}}>
      //           <div className="col">
      //
      //             <div style={{display: "flex"}}>
      //
      //               <div style={{display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "black", border: "2px solid #aaa", borderRadius: "20px", padding: "4px 20px 4px 20px", maxWidth: "152px"}}>
      //                 <AppLogo width="100" place="about"/>
      //               </div>
      //
      //               <div style={{paddingLeft: "20px"}}>
      //
      //                 <div style={{fontSize: "30px", fontWeight: "700"}}>
      //                   {env.displayName}
      //                 </div>
      //                 <div style={{fontSize: "20px", fontWeight: "500"}}>
      //                   {intl.msg("app_version", {version: env.appVersion})}
      //                 </div>
      //                 <div style={{marginTop: "10px"}}>
      //                   {intl.msg("footer_copyright", {copyrightYear: new Date().getFullYear(), entityName: env.entityName, entityAddress: env.entityAddress})}
      //                 </div>
      //
      //                 <div style={{display: "flex", marginTop: "44px"}}>
      //                   <div style={{color: "#ccc", marginTop: "4px"}}>
      //                     {intl.msg("footer_terms")}
      //                     <span style={{color: "#555", padding:"0 10px"}}>|</span>
      //                   </div>
      //                   <div style={{color: "#ccc", marginTop: "4px"}}>
      //                     {intl.msg("footer_privacy")}
      //                     <span style={{color: "#555", padding:"0 10px"}}>|</span>
      //                   </div>
      //                   <div style={{color: "#ccc", marginTop: "4px"}}>
      //                     {intl.msg("footer_contact")}
      //                     <span style={{color: "#555", padding:"0 10px"}}>|</span>
      //                   </div>
      //                   <div style={{color: "#ccc", marginTop: "4px"}}>
      //                     {intl.msg("footer_www")}
      //                   </div>
      //                 </div>
      //
      //               </div>
      //
      //             </div>
      //
      //           </div>
      //         </div>
      //       </div>
      //       <div className="modal-footer">
      //         <button type="button" className="btn btn-secondary" style={{marginLeft: "auto"}} data-dismiss="modal">{intl.msg("ok")}</button>
      //       </div>
      //     </div>
      //   </div>
      // </div>
   )
}